//adatvédelem oldal

import React, { useState, useEffect } from 'react';

export default function Privacy() {
  const [info, setInfo] = useState({
    email1: 'Betöltés...',
  });

  useEffect(() => {
    fetch(`/api/shop-info`)
      .then(res => res.json())
      .then(data => {
        if (data) setInfo(data);
      })
      .catch(err => {
        console.error("Hiba az adatok lekérésekor:", err);
        setInfo({ email1: 'Hiba történt az adatok lekérésekor.' });
      })
  }, []);

  return (
    <div className="min-h-screen bg-transparent text-gray-900 dark:text-white transition-colors duration-300">
      <div className="max-w-4xl mx-auto py-20 px-6">
        {/* Fejléc */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-5xl font-black text-[#a855f7] mb-4 uppercase tracking-tighter">
            Adatvédelem
          </h2>
        </div>

        {/* Tartalom rész */}
        <div className="bg-slate-100/5 dark:bg-slate-800/60 rounded-[0.5rem] p-5 sm:p-10 md:p-16 shadow-lg border border-slate-300/80 dark:border-slate-700/80 text-gray-700 dark:text-gray-300 not-italic leading-relaxed transition-colors">
          <div className="space-y-10">
            
            <section>
              <h3 className="text-xl font-black uppercase tracking-tight text-purple-600 dark:text-purple-400 mb-4">
                1. Általános irányelvek
              </h3>
              <p className="font-medium text-gray-600 dark:text-gray-400">
                A FodrászPro Studio elkötelezett a látogatók és vendégek személyes adatainak védelme mellett. Az adatkezelés során a hatályos jogszabályoknak (GDPR) megfelelően járunk el.
              </p>
            </section>

            <section className="pt-8 border-t border-gray-200 dark:border-gray-700">
              <h3 className="text-xl font-black uppercase tracking-tight text-purple-600 dark:text-purple-400 mb-4">
                2. Gyűjtött adatok köre
              </h3>
              <ul className="list-disc ml-6 space-y-2 font-medium text-gray-600 dark:text-gray-400">
                <li>Név (az azonosításhoz)</li>
                <li>E-mail cím (visszaigazoláshoz és belépéshez)</li>
                <li>Telefonszám (időpont egyeztetéshez)</li>
                <li>Foglalási előzmények</li>
              </ul>
            </section>

            <section className="pt-8 border-t border-gray-200 dark:border-gray-700">
              <h3 className="text-xl font-black uppercase tracking-tight text-purple-600 dark:text-purple-400 mb-4">
                3. Az adatkezelés célja
              </h3>
              <p className="font-medium text-gray-600 dark:text-gray-400">
                Az adatokat kizárólag a szolgáltatás igénybevételéhez (időpontfoglalás), a felhasználói fiók fenntartásához és a zavartalan kommunikációhoz használjuk fel. Harmadik félnek adatokat nem adunk ki.
              </p>
            </section>

            <section className="pt-8 border-t border-gray-200 dark:border-gray-700">
              <h3 className="text-xl font-black uppercase tracking-tight text-purple-600 dark:text-purple-400 mb-4">
                4. A Te jogaid
              </h3>
              <p className="font-medium text-gray-600 dark:text-gray-400">
                Bármikor kérheted adataid módosítását, törlését vagy a róluk készült kivonatot az <span className="text-purple-600 dark:text-purple-400 font-bold">{info.email1}</span> e-mail címen.
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
}